import React, { Component } from 'react';
//import { Card } from 'react-bootstrap';
import './footerComponent.css';

export class footerComponents extends Component {
  render() {
    return (
      <footer className='footer'>
        <div className='container'>
          <div className='row'>
            <div className='col text-center'>
              <i className='fas fa-dice-six'>
                <span className='text-muted p-2'>Cancello</span>
              </i>
            </div>
            <div className='col text-center'>
              <i className='fas fa-snowflake'>
                <span className='text-muted p-2'>Caldaia</span>
              </i>
            </div>
            <div className='col text-center'>
              <i className='fas fa-power-off'>
                <span className='text-muted p-2'>Luci</span>
              </i>
            </div>
          </div>
        </div>
        {/* <div className='container'> </div> */}
      </footer>
    );
  }
}

export default footerComponents;
